(() => {
  if (customElements.get('alfuzon-sticky-buy')) return;
  customElements.define('alfuzon-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.form = document.getElementById(this.dataset.formId);
      this.checkout = this.form?.querySelector('[data-ap-product-checkout]');
      if (!this.form || !this.checkout) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.button = this.querySelector('[data-ab-buy]');
      this.message = this.querySelector('[data-ab-message]');
      this.inView = false;
      this.busy = false;
      this.control = () => this.checkout.querySelector('.sr-headless-checkout,.shopify-payment-button__button--unbranded');
      this.sync = () => {
        const selected = this.form.querySelector('[data-at-variant]:checked');
        const available = selected?.dataset.available === 'true';
        const quantity = this.form.querySelector('[name="quantity"]')?.value || '1';
        const pack = selected?.closest('label')?.querySelector('strong')?.textContent.trim() || '';
        this.querySelector('[data-ab-price]').textContent = selected?.dataset.price || '';
        this.querySelector('[data-ab-pack]').textContent = [pack, `${this.dataset.quantityLabel} ${quantity}`].filter(Boolean).join(' · ');
        const pending = this.form.dataset.atPending === 'true' || this.busy || Boolean(this.control()?.disabled);
        this.button.disabled = !available || pending;
        this.button.textContent = !available ? this.dataset.soldLabel : pending ? this.dataset.loadingLabel : this.dataset.buyLabel;
        this.button.setAttribute('aria-busy', String(pending));
        this.hidden = this.inView;
      };
      this.button.addEventListener('click', () => {
        if (this.button.disabled || this.busy || !this.form.reportValidity()) return;
        this.message.textContent = '';
        const control = this.control();
        if (!control || control.disabled || this.checkout.hidden) {
          this.message.textContent = this.dataset.errorLabel;
          this.checkout.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
          return;
        }
        this.busy = true;
        this.sync();
        control.click();
        this.release = setTimeout(() => {this.busy = false;this.sync();}, 1800);
      }, options);
      this.form.addEventListener('change', () => {this.message.textContent = '';queueMicrotask(this.sync);}, options);
      this.form.addEventListener('input', this.sync, options);
      this.mutations = new MutationObserver(this.sync);
      this.mutations.observe(this.form, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','hidden','data-at-pending']});
      this.intersection = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= .5;
        this.sync();
      }, {threshold:[0,.5,1],rootMargin:'-60px 0px -110px 0px'});
      this.intersection.observe(this.checkout);
      this.previewOffset = () => {
        const preview = document.querySelector('#PBarNextFrameWrapper');
        if (preview && this.previewElement !== preview) {
          this.previewElement = preview;
          this.previewResize?.disconnect();
          this.previewResize = new ResizeObserver(this.previewOffset);
          this.previewResize.observe(preview);
        }
        const rect = preview?.getBoundingClientRect();
        const visible = rect && rect.height > 0 && rect.top < innerHeight && rect.bottom > 0;
        const offset = `${visible ? Math.max(0,innerHeight - rect.top) : 0}px`;
        this.style.setProperty('--ab-preview-offset', offset);
        document.body.style.setProperty('--ab-preview-offset', offset);
      };
      window.addEventListener('resize', this.previewOffset, options);
      window.addEventListener('pageshow', () => {this.busy = false;this.sync();this.previewOffset();}, options);
      this.previewObserver = new MutationObserver(this.previewOffset);
      this.previewObserver.observe(document.body,{childList:true});
      document.body.classList.add('ab-has-buy-bar');
      this.sync();
      this.previewOffset();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.intersection?.disconnect();
      this.mutations?.disconnect();
      this.previewObserver?.disconnect();
      this.previewResize?.disconnect();
      clearTimeout(this.release);
      this.controller = null;
      document.body.classList.remove('ab-has-buy-bar');
    }
  });
})();
